var CartButton = Backbone.View.extend({
    events: {
        'click' : 'triggerFlyOut'
    },
    initialize: function(){
        _.bindAll( 
            this, 
            'updateCountBadge',
            'triggerFlyOut'
        );
        this.listenTo( this.model, 'change:count', this.updateCountBadge );
        
    },
    updateCountBadge: function(){
        var count = this.model.get( 'count' );
        this.$('span.badge').remove();
        if ( count > 0 ) {
            this.$el.append( '<span class="badge">'+count+'</span>' );
        }
    },
    triggerFlyOut: function( e ){
        e.preventDefault();
        this.model.showSideCart();
    }
});

export {CartButton};